document.addEventListener('DOMContentLoaded', () => {
    const RECENT_SEARCHES_KEY = 'store_recent_searches';
    const MAX_RECENT_SEARCHES = 5;

    function getRecentSearches() {
        try {
            const stored = localStorage.getItem(RECENT_SEARCHES_KEY);
            return stored ? JSON.parse(stored) : [];
        } catch (e) {
            console.error('Error reading recent searches:', e);
            return [];
        }
    }

    function saveRecentSearch(query) {
        if (!query || query.trim().length < 1) return;

        const trimmedQuery = query.trim();
        let searches = getRecentSearches();

        searches = searches.filter(s => s.toLowerCase() !== trimmedQuery.toLowerCase());

        const lowerNew = trimmedQuery.toLowerCase();
        searches = searches.filter(s => {
            const lowerS = s.toLowerCase();
            return !(lowerNew.startsWith(lowerS) && lowerS.length < lowerNew.length);
        });

        searches.unshift(trimmedQuery);

        searches = searches.slice(0, MAX_RECENT_SEARCHES);

        try {
            localStorage.setItem(RECENT_SEARCHES_KEY, JSON.stringify(searches));
        } catch (e) {
            console.error('Error saving recent search:', e);
        }
    }

    async function renderRecentSearches() {
        const section = document.getElementById('recent-searches-section');
        const list = document.getElementById('recent-searches-list');
        const loader = document.getElementById('recent-searches-loader');
        if (!section || !list) return;

        const searches = getRecentSearches();
        if (searches.length === 0) {
            section.classList.add('hidden');
            return;
        }

        section.classList.remove('hidden');
        if (loader) {
            loader.classList.remove('hidden');
        }
        list.classList.add('hidden');

        let url = null;
        try {
            const queriesParam = searches.join(',');
            url = new URL(`${window.location.origin}/pages/pickleball`);
            url.searchParams.set('sections', 'recent-searches');
            url.searchParams.set('queries', queriesParam);

            const response = await fetch(url.toString());
            if (!response.ok) {
                throw new Error(`HTTP ${response.status}`);
            }

            const responseData = await response.json();

            let sectionHTML = responseData['recent-searches'] ||
                responseData['shopify-section-recent-searches'] ||
                '';

            if (!sectionHTML && Object.keys(responseData).length > 0) {
                for (const key of Object.keys(responseData)) {
                    const value = responseData[key];
                    if (value === null) continue;
                    if (key.includes('recent-searches') || key.includes('recent_searches') ||
                        key.match(/shopify-section-.*__recent-searches/i)) {
                        sectionHTML = value;
                        break;
                    }
                }
                if (!sectionHTML) {
                    for (const key of Object.keys(responseData)) {
                        if (responseData[key] !== null) {
                            sectionHTML = responseData[key];
                            break;
                        }
                    }
                }
            }

            if (!sectionHTML || sectionHTML.trim().length === 0) {
                throw new Error('No section data returned');
            }

            if (sectionHTML.includes('No recent searches')) {
                section.classList.add('hidden');
                if (loader) loader.classList.add('hidden');
                return;
            }

            if (sectionHTML.includes('<html') || sectionHTML.includes('<head') || sectionHTML.includes('<body')) {
                throw new Error('Invalid response: received full page HTML');
            }

            const parser = new DOMParser();
            const doc = parser.parseFromString(sectionHTML, 'text/html');

            let contentWrapper = doc.querySelector('#recent-searches-content') ||
                doc.querySelector('.recent-searches-content');

            if (!contentWrapper) {
                const sectionWrapper = doc.querySelector('#shopify-section-recent-searches') ||
                    doc.querySelector('[id*="recent-searches"]') ||
                    doc.querySelector('[id*="recent_searches"]') ||
                    doc.querySelector('section.shopify-section');
                if (sectionWrapper) {
                    contentWrapper = sectionWrapper.querySelector('#recent-searches-content') ||
                        sectionWrapper.querySelector('.recent-searches-content');
                }
            }

            if (!contentWrapper && doc.body) {
                contentWrapper = doc.body.querySelector('#recent-searches-content') ||
                    doc.body.querySelector('.recent-searches-content');
            }

            let content = '';
            if (contentWrapper?.innerHTML.trim()) {
                content = contentWrapper.innerHTML.trim();
            } else if (doc.body) {
                const listItems = doc.body.querySelectorAll('li');
                if (listItems.length > 0) {
                    content = Array.from(listItems).map(item => item.outerHTML).join('');
                }
            }

            if (content && content.length > 0) {
                if (!list.isConnected || !section.isConnected) {
                    if (loader && loader.isConnected) loader.classList.add('hidden');
                    return;
                }
                list.innerHTML = content;
                list.classList.remove('hidden');
                if (loader) loader.classList.add('hidden');
                section.classList.remove('hidden');
            } else {
                section.classList.add('hidden');
                if (loader) loader.classList.add('hidden');
            }
        } catch (e) {
            console.error('Error rendering recent searches:', e);
            console.error('Failed URL:', url?.toString() || 'N/A');
            const loader = document.getElementById('recent-searches-loader');
            if (loader) loader.classList.add('hidden');
            section.classList.add('hidden');
        }
    }

    function trackSearch(query) {
        if (query && query.trim().length >= 1) {
            saveRecentSearch(query);
        }
    }

    window.searchRecentSearches = {
        getRecentSearches,
        saveRecentSearch,
        renderRecentSearches,
        trackSearch
    };
});

